// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/fonts/Inter-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/assets/fonts/Inter-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/src/assets/fonts/Inter-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/src/assets/fonts/Inter-ExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/src/assets/fonts/Inter-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/src/assets/fonts/Inter-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/src/assets/fonts/Inter-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("/src/assets/fonts/Inter-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("/src/assets/fonts/Inter-Thin.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: InterBlack;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
  font-family: InterBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

@font-face {
  font-family: InterExtraBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@font-face {
  font-family: InterExtraLight;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

@font-face {
  font-family: InterLight;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

@font-face {
  font-family: InterMedium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

@font-face {
  font-family: InterRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

@font-face {
  font-family: InterSemibold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

@font-face {
  font-family: InterThin;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    'InterRegular', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

h1,
h2,
h3,
p,
span {
  font-family: var(--FONT_DEFAULT);
  font-style: normal;
  font-weight: var(--WEIGHT_NORMAL);
  margin: 0; /* pixel perfect */
  padding: 0; /* pixel perfect */
  text-align: left;
}

.shadowLight {
  box-shadow: 0 var(--SIZE_1) var(--SIZE_2) var(--COLOR_GRAY_900_LIGHT);
}

.topMenuText {
  font-family: var(--FONT_SEMIBOLD);
  font-size: var(--FONT_SIZE_TEXT);
  font-weight: var(--WEIGHT_600);
  line-height: var(--LINE_HEIGHT_20);
}

.buttonText {
  font-family: var(--FONT_SEMIBOLD);
  font-size: var(--FONT_SIZE_TEXT);
  font-weight: var(--WEIGHT_400);
  line-height: var(--LINE_HEIGHT_24);
  color: var(--COLOR_FOREGROUND);
}

.weightText {
  font-family: var(--FONT_SEMIBOLD);
  font-size: var(--FONT_SIZE_SUB_TITLE);
  font-weight: var(--WEIGHT_600);
  line-height: var(--LINE_HEIGHT_24);
  color: var(--COLOR_PRIMARY_950);
}

.errorText {
  font-family: var(--FONT_MEDIUM);
  font-size: var(--FONT_SIZE_TEXT);
  font-weight: var(--WEIGHT_NORMAL);
  line-height: var(--LINE_HEIGHT_20);
  color: var(--COLOR_FAILED_50);
}

.titleText {
  font-family: var(--FONT_SEMIBOLD);
  font-size: var(--FONT_SIZE_TEXT_TITLE);
  font-weight: var(--WEIGHT_600);
  line-height: var(--LINE_HEIGHT_28);
}

.contentText {
  font-family: var(--FONT_DEFAULT);
  font-size: var(--FONT_SIZE_TEXT);
  font-weight: var(--WEIGHT_400);
  line-height: var(--LINE_HEIGHT_20);
}

.subtitle {
  font-family: var(--FONT_DEFAULT);
  font-size: var(--FONT_SIZE_SUB_TITLE);
  font-weight: var(--WEIGHT_400);
  color: var(--COLOR_GRAY_500);
}

.subtitleMedium {
  font-family: var(--FONT_MEDIUM);
  font-size: var(--FONT_SIZE_SUB_TITLE);
  font-weight: var(--WEIGHT_NORMAL);
  color: var(--COLOR_GRAY_900);
}

.subtitleBold {
  font-family: var(--FONT_SEMIBOLD);
  font-size: var(--FONT_SIZE_SUB_TITLE);
  font-weight: var(--WEIGHT_600);
  color: var(--COLOR_PRIMARY_950);
}

.tableTitleText {
  font-family: var(--FONT_MEDIUM);
  font-size: var(--FONT_SIZE_TEXT_TITLE);
  font-weight: var(--WEIGHT_NORMAL);
  line-height: var(--LINE_HEIGHT_28);
  color: var(--COLOR_GRAY_900);
}

.warningTextColor {
  color: var(--COLOR_FAILED_50);
}
`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,4CAA2C;AAC7C;;AAEA;EACE,sBAAsB;EACtB,4CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,4CAA+C;AACjD;;AAEA;EACE,4BAA4B;EAC5B,4CAAgD;AAClD;;AAEA;EACE,uBAAuB;EACvB,4CAA2C;AAC7C;;AAEA;EACE,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,4CAA6C;AAC/C;;AAEA;EACE,0BAA0B;EAC1B,4CAA8C;AAChD;;AAEA;EACE,sBAAsB;EACtB,4CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT;;8BAE4B;EAC5B,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;;;;;EAKE,gCAAgC;EAChC,kBAAkB;EAClB,iCAAiC;EACjC,SAAS,EAAE,kBAAkB;EAC7B,UAAU,EAAE,kBAAkB;EAC9B,gBAAgB;AAClB;;AAEA;EACE,qEAAqE;AACvE;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,8BAA8B;EAC9B,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,8BAA8B;EAC9B,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,iCAAiC;EACjC,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,sCAAsC;EACtC,iCAAiC;EACjC,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":["@font-face {\n  font-family: InterBlack;\n  src: url(/src/assets/fonts/Inter-Black.ttf);\n}\n\n@font-face {\n  font-family: InterBold;\n  src: url(/src/assets/fonts/Inter-Bold.ttf);\n}\n\n@font-face {\n  font-family: InterExtraBold;\n  src: url(/src/assets/fonts/Inter-ExtraBold.ttf);\n}\n\n@font-face {\n  font-family: InterExtraLight;\n  src: url(/src/assets/fonts/Inter-ExtraLight.ttf);\n}\n\n@font-face {\n  font-family: InterLight;\n  src: url(/src/assets/fonts/Inter-Light.ttf);\n}\n\n@font-face {\n  font-family: InterMedium;\n  src: url(/src/assets/fonts/Inter-Medium.ttf);\n}\n\n@font-face {\n  font-family: InterRegular;\n  src: url(/src/assets/fonts/Inter-Regular.ttf);\n}\n\n@font-face {\n  font-family: InterSemibold;\n  src: url(/src/assets/fonts/Inter-SemiBold.ttf);\n}\n\n@font-face {\n  font-family: InterThin;\n  src: url(/src/assets/fonts/Inter-Thin.ttf);\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    'InterRegular', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\nh1,\nh2,\nh3,\np,\nspan {\n  font-family: var(--FONT_DEFAULT);\n  font-style: normal;\n  font-weight: var(--WEIGHT_NORMAL);\n  margin: 0; /* pixel perfect */\n  padding: 0; /* pixel perfect */\n  text-align: left;\n}\n\n.shadowLight {\n  box-shadow: 0 var(--SIZE_1) var(--SIZE_2) var(--COLOR_GRAY_900_LIGHT);\n}\n\n.topMenuText {\n  font-family: var(--FONT_SEMIBOLD);\n  font-size: var(--FONT_SIZE_TEXT);\n  font-weight: var(--WEIGHT_600);\n  line-height: var(--LINE_HEIGHT_20);\n}\n\n.buttonText {\n  font-family: var(--FONT_SEMIBOLD);\n  font-size: var(--FONT_SIZE_TEXT);\n  font-weight: var(--WEIGHT_400);\n  line-height: var(--LINE_HEIGHT_24);\n  color: var(--COLOR_FOREGROUND);\n}\n\n.weightText {\n  font-family: var(--FONT_SEMIBOLD);\n  font-size: var(--FONT_SIZE_SUB_TITLE);\n  font-weight: var(--WEIGHT_600);\n  line-height: var(--LINE_HEIGHT_24);\n  color: var(--COLOR_PRIMARY_950);\n}\n\n.errorText {\n  font-family: var(--FONT_MEDIUM);\n  font-size: var(--FONT_SIZE_TEXT);\n  font-weight: var(--WEIGHT_NORMAL);\n  line-height: var(--LINE_HEIGHT_20);\n  color: var(--COLOR_FAILED_50);\n}\n\n.titleText {\n  font-family: var(--FONT_SEMIBOLD);\n  font-size: var(--FONT_SIZE_TEXT_TITLE);\n  font-weight: var(--WEIGHT_600);\n  line-height: var(--LINE_HEIGHT_28);\n}\n\n.contentText {\n  font-family: var(--FONT_DEFAULT);\n  font-size: var(--FONT_SIZE_TEXT);\n  font-weight: var(--WEIGHT_400);\n  line-height: var(--LINE_HEIGHT_20);\n}\n\n.subtitle {\n  font-family: var(--FONT_DEFAULT);\n  font-size: var(--FONT_SIZE_SUB_TITLE);\n  font-weight: var(--WEIGHT_400);\n  color: var(--COLOR_GRAY_500);\n}\n\n.subtitleMedium {\n  font-family: var(--FONT_MEDIUM);\n  font-size: var(--FONT_SIZE_SUB_TITLE);\n  font-weight: var(--WEIGHT_NORMAL);\n  color: var(--COLOR_GRAY_900);\n}\n\n.subtitleBold {\n  font-family: var(--FONT_SEMIBOLD);\n  font-size: var(--FONT_SIZE_SUB_TITLE);\n  font-weight: var(--WEIGHT_600);\n  color: var(--COLOR_PRIMARY_950);\n}\n\n.tableTitleText {\n  font-family: var(--FONT_MEDIUM);\n  font-size: var(--FONT_SIZE_TEXT_TITLE);\n  font-weight: var(--WEIGHT_NORMAL);\n  line-height: var(--LINE_HEIGHT_28);\n  color: var(--COLOR_GRAY_900);\n}\n\n.warningTextColor {\n  color: var(--COLOR_FAILED_50);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
